import { composeUrl } from "@foundation/util";
import { useRouter } from "next/router";

export default function useLink() {
  const { locale } = useRouter();

  return {
    open: (url: string, target?: string, features?: string) => {
      const urlWithLocale = composeUrl({
        pathname: `${locale === "en" ? "/" : `/${locale}/`}${url}`,
      });

      window.open(urlWithLocale, target, features);
    },
  };
}
